import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { clearAuth } from '@/utils/authSession';




import { forgotPasswordRtkKey, getEventListRtkKey, getPhoneCodeRtkKey, getServiceTypesRtkKey, getCargoTypesRtkKey, getCarriersRtkKey, loginRtkKey, simpleCreateUserRtkKey, simpleUpdateUserRtkKey, signupRtkKey, verifyOtpRtkKey, createEnquiryRtkKey, deleteEnquiryRtkKey, submitDraftRtkKey, resetPasswordRtkKey, resendOtpRtkKey, updateDetailsRtkKey, getProfileRtkKey, getTrackingListRtkKey, getReturnTrackingListRtkKey, refreshTrackingStatusRtkKey, getShippingTrackingDetailsRtkKey, getReturnTrackingDetailsRtkKey, downloadBundleRtkKey, getOrganisersListRtkKey, getStandTypesRtkKey, getDimensionsListRtkKey, getWeightsListRtkKey, validateOrganiserPasscodeRtkKey, initiatePaymentRtkKey, checkPaymentStatusRtkKey, getPaymentListRtkKey, getPaymentDetailsRtkKey, adminGetFeedbacksRtkKey, adminDashboardRtkKey, getAdminFMDashboardRtkKey, adminEventShowDashboardRtkKey, saveDashboardLayoutRtkKey, saveAdminFmLayoutRtkKey, adminGetEventListRtkKey, createLabelRtkKey, adminGetEnquiriesListRtkKey, getAllOrganisersListRtkKey, getAllEventsListRtkKey, getAllExhibitorsListRtkKey, getExhibitorListRtkKey, getEnquiryByIdRtkKeyV2, updateEnquiryRtkKeyKey, adminGetWHListRtkKey, updateAdminWHRtkKey, createAdminWHRtkKey, createAdminEventRtkKey, updateAdminEventRtkKey, createAdminOrganiserRtkKey, updateAdminOrganiserRtkKey, getTeamListRtkKey, addTeamRtkKey, deleteTeamRtkKey, getMemberListRtkKey, addMemberRtkKey, updateMemberRtkKey, softDeleteMemberRtkKey, generateManifestRtkKey, processFormWithAutoFormCreationRtkKey, generateExcelRtkKey, genManifestJSONRtkKey, createEnqJSONRtkKey, getEnquiryMetaRtkKey, updateEnquiryMetaRtkKey, getEnquiryListSimpleRtkKey, updateTeamRtkKey, createCarrierRtkKey, sendOtpToPhoneRtkKey, verifyMobileOtpRtkKey   } from '@/utils/rtkKeys';

import { getEventListApi, getPhoneCodeApi, getServiceTypesApi, getCargoTypesApi, getCarriersApi, createCarrierApi, loginApi, simpleCreateUserApi, simpleUpdateUserApi, sendOtpApi, signupApi, verifyOtpApi, createEnquiryApi, deleteEnquiryApi, submitDraftApi, resetPasswordApi, resendOtpApi, updateDetailsApi, getProfileApi, getTrackingListApi, getReturnTrackingListApi, downloadBundleApi, getOrganisersListApi, getStandTypesApi, getDimensionsListApi, getWeightsListApi, validateOrganiserPasscodeApi, initiatePaymentApi, checkPaymentStatusApi, getPaymentListApi, getPaymentDetailsApi, getFeedbacksApi, getAdminDashboardApi, getAdminEventShowDashboardApi, saveDashboardLayoutApi, saveAdminFmLayoutApi, getAdminEventListApi, createLabelApi, getAdminEnquiriesListApi, getAllOrganisersListApi, getAllEventsListApi, getAllExhibitorsListApi, getExhibitorListApi, getEnquiryByIdApiV2, updateEnquiryApi, getAdminWHListApi, updateAdminWHApi, createAdminWHApi, createAdminEventApi, updateAdminEventApi, createAdminOrganiserApi, updateAdminOrganiserApi, getTeamListApi, addTeamApi, updateTeamApi, deleteTeamApi, getMemberListApi, addMemberApi, updateMemberApi, deleteMemberApi, generateManifestApi, processFormWithAutoFormCreationApi, generateExcelApi, genManifestJSONApi, createEnqJsonApi, getEnquiryMetaApi, updateEnquiryMetaApi, getEnquiryListSimpleApi, getAdminFMDashboardApi, sendOtpToPhoneApi, verifyMobileOtpApi } from './apiService';

const CARRIERS_QUERY_STALE_MS = 5 * 60 * 1000;
const PROFILE_QUERY_STALE_MS = 5 * 60 * 1000;
const carriersQueryKey = [getCarriersRtkKey] as const;

export function useLoginMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [loginRtkKey],
    mutationFn: async (payload: any) => {
      const response = await loginApi(payload);
      return response;
    },
  });
}

export function useSimpleCreateUserMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [simpleCreateUserRtkKey],
    mutationFn: async (payload: any) => {
      const response = await simpleCreateUserApi(payload);
      return response;
    },
  });
}

export function useSimpleUpdateUserMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [simpleUpdateUserRtkKey],
    mutationFn: async (payload: any) => {
      const response = await simpleUpdateUserApi(payload);
      return response;
    },
  });
}

export function useSendOtpMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [forgotPasswordRtkKey],
    mutationFn: async (payload: any) => {
      const response = await sendOtpApi(payload);
      return response;
    },
  });
}

export function useSignupMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [signupRtkKey],
    mutationFn: async (payload: any) => {
      const response = await signupApi(payload);
      return response;
    },
  });
}

export function useSendOtpToPhoneMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [sendOtpToPhoneRtkKey],
    mutationFn: async (payload: any) => {
      const response = await sendOtpToPhoneApi(payload);
      return response;
    },
  });
}

export function useVerifyMobileOtpMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [verifyMobileOtpRtkKey],
    mutationFn: async (payload: any) => {
      const response = await verifyMobileOtpApi(payload);
      return response;
    },
  });
}

export function useVerifyOtpMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [verifyOtpRtkKey],
    mutationFn: async (payload: any) => {
      const response = await verifyOtpApi(payload);
      return response;
    },
  });
}

export function useGetPhoneCodeQuery() {
  return useQuery<any, Error, any>({
    queryKey: [getPhoneCodeRtkKey],
    queryFn: async () => {
      const response = await getPhoneCodeApi();
      return response;
    },
  });
}

export function useGetEventListQuery() {
  return useQuery<any, Error, any>({
    queryKey: [getEventListRtkKey],
    queryFn: async () => {
      const response = await getEventListApi();
      return response;
    },
  });
}

export function useGetEnquiryListSimpleQuery(params: any = {}, options: any = {}) {
  return useQuery<any, Error, any>({
    queryKey: [getEnquiryListSimpleRtkKey, params],
    queryFn: async ({ queryKey }) => {
      const [_key, actualParams] = queryKey;
      const response = await getEnquiryListSimpleApi(actualParams);
      return response;
    },
    ...options
  });
}

export function useGetServiceTypesQuery() {
  return useQuery<any, Error, any>({
    queryKey: [getServiceTypesRtkKey],
    queryFn: async () => {
      const response = await getServiceTypesApi();
      return response;
    },
  });
}

export function useGetCargoTypesQuery() {
  return useQuery<any, Error, any>({
    queryKey: [getCargoTypesRtkKey],
    queryFn: async () => {
      const response = await getCargoTypesApi();
      return response;
    },
  });
}

export function useGetCarriersQuery() {
  return useQuery<any, Error, any>({
    queryKey: [...carriersQueryKey],
    queryFn: async () => {
      const response = await getCarriersApi();
      return response?.data;
    },
    staleTime: CARRIERS_QUERY_STALE_MS,
  });
}

export function useCreateCarrierMutation() {
  const queryClient = useQueryClient();
  return useMutation<any, Error, any>({
    mutationKey: [createCarrierRtkKey],
    mutationFn: async (payload) => {
      const response = await createCarrierApi(payload);
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [...carriersQueryKey] });
    },
  });
}

export function useResetPasswordMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [resetPasswordRtkKey],
    mutationFn: async (data: any) => {
      const response = await resetPasswordApi(data);
      return response;
    },
  });
}

export function useResendOtpMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [resendOtpRtkKey],
    mutationFn: async (data: any) => {
      const response = await resendOtpApi(data);
      return response;
    },
  });
}

export function useUpdateDetailsMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [updateDetailsRtkKey],
    mutationFn: async (data: any) => {
      const response = await updateDetailsApi(data);
      return response;
    },
  });
}

export function useGetProfileQuery() {
  return useQuery<any, Error, any>({
    queryKey: [getProfileRtkKey],
    queryFn: async () => {
      const response = await getProfileApi();
      if(response?.data?.data && typeof response?.data?.data === 'object' && Object.keys(response?.data?.data).length > 0) {
        localStorage.setItem('user', JSON.stringify(response?.data?.data));
      }
      return response;
    },
    staleTime: PROFILE_QUERY_STALE_MS,
    refetchOnMount: false,
  });
}


export function useGetTrackingListQuery(params: any = {}, options: any = {}) {
  return useQuery<any, Error, any>({
    queryKey: [getTrackingListRtkKey, params],
    queryFn: async ({ queryKey }) => {
      const [_key, actualParams] = queryKey;
      const response = await getTrackingListApi(actualParams);
      return response;
    },
    ...options
  });
}

export function useGetReturnTrackingListQuery(params: any = {}, options: any = {}) {
  return useQuery<any, Error, any>({
    queryKey: [getReturnTrackingListRtkKey, params],
    queryFn: async ({ queryKey }) => {
      const [_key, actualParams] = queryKey;
      const response = await getReturnTrackingListApi(actualParams);
      return response;
    },
    ...options
  });
}

export function useDownloadBundleQuery(id: any) {
  return useQuery<any, Error, any>({
    queryKey: [downloadBundleRtkKey, id],
    queryFn: async ({ queryKey }) => {
      const [_key, actualId] = queryKey;
      const response = await downloadBundleApi(actualId);
      return response;
    },
    staleTime: 0,
    gcTime: 0,
    enabled: false
  });
}



export function useGetOrganisersListQuery(params: any = {}, options: any = {}) {
  return useQuery<any, Error, any>({
    queryKey: [getOrganisersListRtkKey, params],
    queryFn: async ({ queryKey }) => {
      const [_key, actualParams] = queryKey;
      const response = await getOrganisersListApi(actualParams);
      return response;
    },
    staleTime: 0,
    gcTime: 0,
    enabled: true
  });
}

export function useGetAllOrganisersListQuery(enabled: boolean = true) {
  return useQuery<any, Error, any>({
    queryKey: [getAllOrganisersListRtkKey],
    queryFn: async () => {
      const response = await getAllOrganisersListApi();
      return response;
    },
    enabled: enabled
  });
}

export function useGetAllEventsListQuery(enabled: boolean = true) {
  return useQuery<any, Error, any>({
    queryKey: [getAllEventsListRtkKey],
    queryFn: async () => {
      const response = await getAllEventsListApi();
      return response;
    },
    enabled: enabled
  });
}

export function useGetAllExhibitorsListQuery(enabled: boolean = true) {
  return useQuery<any, Error, any>({
    queryKey: [getAllExhibitorsListRtkKey],
    queryFn: async () => {
      const response = await getAllExhibitorsListApi();
      return response;
    },
    enabled: enabled
  });
}


export function useGenerateExcelQuery(enquiry_id: string, update_method: string) {
  return useQuery<any, Error, any>({
    queryKey: [generateExcelRtkKey, enquiry_id, update_method],
    queryFn: async ({ queryKey }) => {
      const [_key, actualEnquiryId, actualUpdateMethod] = queryKey;
      const response = await generateExcelApi(actualEnquiryId as string, actualUpdateMethod as string);
      return response;
    },
    enabled: !!enquiry_id && !!update_method
  });
}


















//enquiries
export function useGetAdminEnquiriesListQuery() {
  return useMutation<any, Error, any>({
    mutationKey: [adminGetEnquiriesListRtkKey],
    mutationFn: async (payload: any) => {
      const response = await getAdminEnquiriesListApi(payload);
      return response;
    }
  });
}


export function useGetEnquiryByIdQueryV2(enquiry_id: any) {
  return useQuery<any, Error, any>({
    queryKey: [getEnquiryByIdRtkKeyV2, enquiry_id],
    queryFn: async ({ queryKey }) => {
      const [_key, actualId] = queryKey;
      const response = await getEnquiryByIdApiV2(actualId);
      return response;
    },
    enabled: !!enquiry_id,
    staleTime: 0,
    refetchOnMount: 'always',
  });
}

export function useGetEnquiryMetaQuery(enquiry_id: any, options: any = {}) {
  return useQuery<any, Error, any>({
    queryKey: [getEnquiryMetaRtkKey, enquiry_id],
    queryFn: async ({ queryKey }) => {
      const [_key, actualId] = queryKey;
      const response = await getEnquiryMetaApi(actualId);
      return response;
    },
    enabled: !!enquiry_id,
    ...options
  });
}

export function useGetAdminFMDashboardQuery(params: Record<string, unknown>, options: any = {}) {
  return useQuery<any, Error, any>({
    queryKey: [getAdminFMDashboardRtkKey, params],
    queryFn: async ({ queryKey }) => {
      const [_key, queryParams] = queryKey;
      const response = await getAdminFMDashboardApi(queryParams as Record<string, unknown>);
      const res = response as { data?: unknown };
      return res?.data;
    },
    ...options,
    enabled: true,
  });
}

export function useCreateEnquiryMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [createEnquiryRtkKey],
    mutationFn: async (payload: any) => {
      const response = await createEnquiryApi(payload);
      return response;
    },
  });
}

export function useUpdateEnquiryMetaMutation(enquiry_id: string) {
  return useMutation<any, Error, any>({
    mutationKey: [updateEnquiryMetaRtkKey],
    mutationFn: async (payload: any) => {
      const response = await updateEnquiryMetaApi(payload, enquiry_id as string);
      return response;
    },
  });
}

export function useUpdateEnquiryMutation(enquiry_id: string) {
  const queryClient = useQueryClient();
  return useMutation<any, Error, any>({
    mutationKey: [updateEnquiryRtkKeyKey],
    mutationFn: async (payload: any) => {
      const response = await updateEnquiryApi(payload, enquiry_id as string);
      return response;
    },
    onSuccess: () => {
      if (enquiry_id) {
        queryClient.invalidateQueries({ queryKey: [getEnquiryByIdRtkKeyV2, enquiry_id] });
      }
    },
  });
}

export function useDeleteEnquiryMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [deleteEnquiryRtkKey],
    mutationFn: async (id: any) => {
      const response = await deleteEnquiryApi(id);
      return response;
    },
  });
}

export function useSubmitDraftMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [submitDraftRtkKey],
    mutationFn: async (id: any) => {
      const response = await submitDraftApi(id);
      return response;
    },
  });
}

















export function useGetStandTypesQuery(service_type_id: any, venue: any, region: any) {
  return useQuery<any, Error, any>({
    queryKey: [getStandTypesRtkKey, service_type_id, venue, region],
    queryFn: async ({ queryKey }) => {
      const [_key, actualServiceTypeId, actualVenue, actualRegion] = queryKey;
      const response = await getStandTypesApi(actualServiceTypeId, actualVenue, actualRegion);
      return response;
    },
  });
}




export function useGetDimensionsListQuery() {
  return useQuery<any, Error, any>({
    queryKey: [getDimensionsListRtkKey],
    queryFn: async () => {
      const response = await getDimensionsListApi();
      return response;
    },
  });
}


export function useGetWeightsListQuery() {
  return useQuery<any, Error, any>({
    queryKey: [getWeightsListRtkKey],
    queryFn: async () => {
      const response = await getWeightsListApi();
      return response;
    },
  });
}


export function useValidateOrganiserPasscodeMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [validateOrganiserPasscodeRtkKey],
    mutationFn: async (payload: any) => {
      const response = await validateOrganiserPasscodeApi(payload);
      return response;
    },
  });
}


export function useInitiatePaymentMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [initiatePaymentRtkKey],
    mutationFn: async (payload: any) => {
      const response = await initiatePaymentApi(payload);
      return response;
    },
  });
}

export function useCheckPaymentStatusMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [checkPaymentStatusRtkKey],
    mutationFn: async (payload: any) => {
      const response = await checkPaymentStatusApi(payload);
      return response;
    },
  });
}


export function useGetPaymentListQuery(params: any = {}, options: any = {}) {
  return useQuery<any, Error, any>({
    queryKey: [getPaymentListRtkKey, params],
    queryFn: async ({ queryKey }) => {
      const [_key, actualParams] = queryKey;
      const response = await getPaymentListApi(actualParams);
      return response;
    },
  });
}

export function useGetPaymentDetailsQuery(payment_id: any) {
  return useQuery<any, Error, any>({
    queryKey: [getPaymentDetailsRtkKey, payment_id],
    queryFn: async ({ queryKey }) => {
      const [_key, actualId] = queryKey;
      const response = await getPaymentDetailsApi(actualId);
      return response;
    },
    enabled: !!payment_id
  });
}




// admin
export function useGetFeedbacksQuery(params: any = {}, options: any = {}) {
  return useQuery<any, Error, any>({
    queryKey: [adminGetFeedbacksRtkKey, params],
    queryFn: async ({ queryKey }) => {
      const [_key, actualParams] = queryKey;
      const response = await getFeedbacksApi(actualParams);
      return response;
    },
    ...options
  });
}

export function useGetAdminDashboardQuery() {
  return useQuery<any, Error, any>({
    queryKey: [adminDashboardRtkKey],
    queryFn: async () => {
      const response = await getAdminDashboardApi();
      return response;
    },
  });
}

export function useGetAdminEventShowDashboardQuery(eventId: string | undefined, options: any = {}) {
  return useQuery<any, Error, any>({
    queryKey: [adminEventShowDashboardRtkKey, eventId],
    queryFn: async () => {
      const response = await getAdminEventShowDashboardApi(eventId as string);
      return response;
    },
    ...options,
  });
}

export function useSaveDashboardLayoutMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [saveDashboardLayoutRtkKey],
    mutationFn: async (payload: any) => {
      const response = await saveDashboardLayoutApi(payload);
      return response;
    },
  });
}

export function useSaveAdminFmLayoutMutation() {
  return useMutation<any, Error, unknown>({
    mutationKey: [saveAdminFmLayoutRtkKey],
    mutationFn: async (payload: unknown) => {
      const response = await saveAdminFmLayoutApi(payload);
      return response;
    },
  });
}

export function useGetAdminEventListQuery() {
  return useMutation<any, Error, any>({
    mutationKey: [adminGetEventListRtkKey],
    mutationFn: async (payload: any) => {
      const response = await getAdminEventListApi(payload);
      return response;
    },
  });
}

export function useGetAdminWHListQuery(params: any = {}, options: any = {}) {
  return useQuery<any, Error, any>({
    queryKey: [adminGetWHListRtkKey, params],
    queryFn: async ({ queryKey }) => {
      const [_key, actualParams] = queryKey;
      const response = await getAdminWHListApi(actualParams);
      return response;
    },
    ...options
  });
}

export function useGetExhibitorListQuery(params: any = {}, options: any = {}) {
  return useQuery<any, Error, any>({
    queryKey: [getExhibitorListRtkKey, params],
    queryFn: async ({ queryKey }) => {
      const [_key, actualParams] = queryKey;
      const response = await getExhibitorListApi(actualParams);
      return response;
    },
    ...options,
  });
}

export function useCreateLabelMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [createLabelRtkKey],
    mutationFn: async (payload: any) => {
      const response = await createLabelApi(payload);
      return response;
    },
  });
}



export function useUpdateAdminWHMutation(warehouse_id: string) {
  return useMutation<any, Error, any>({
    mutationKey: [updateAdminWHRtkKey],
    mutationFn: async (payload: any) => {
      const response = await updateAdminWHApi(payload, warehouse_id);
      return response;
    },
  });
}


export function useCreateAdminWHMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [createAdminWHRtkKey],
    mutationFn: async (payload: any) => {
      const response = await createAdminWHApi(payload);
      return response;
    },
  });
}

export function useCreateAdminEventMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [createAdminEventRtkKey],
    mutationFn: async (payload: any) => {
      const response = await createAdminEventApi(payload);
      return response;
    },
  });
}

export function useUpdateAdminEventMutation(event_id: string) {
  return useMutation<any, Error, any>({
    mutationKey: [updateAdminEventRtkKey],
    mutationFn: async (payload: any) => {
      const response = await updateAdminEventApi(payload, event_id);
      return response;
    },
  });
}

export function useGenerateManifestMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [generateManifestRtkKey],
    mutationFn: async (payload: any) => {
      const response = await generateManifestApi(payload);
      return response;
    },
  });
}

export function useProcessFormWithAutoFormCreationMutation() {
  return useMutation<any, Error, { file: File; signal?: AbortSignal }>({
    mutationKey: [processFormWithAutoFormCreationRtkKey],
    mutationFn: async ({ file, signal }) => {
      const response = await processFormWithAutoFormCreationApi(file, signal);
      return response;
    },
  });
}

export function useCreateAdminOrganiserMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [createAdminOrganiserRtkKey],
    mutationFn: async (payload: any) => {
      const response = await createAdminOrganiserApi(payload);
      return response;
    },
  });
}

export function useUpdateAdminOrganiserMutation(organiser_id: string) {
  return useMutation<any, Error, any>({
    mutationKey: [updateAdminOrganiserRtkKey],
    mutationFn: async (payload: any) => {
      const response = await updateAdminOrganiserApi(payload, organiser_id);
      return response;
    },
  });
}

// Teams
export function useGetTeamListQuery(params?: { page?: number; page_size?: number }, options?: any) {
  return useQuery<any, Error, any>({
    queryKey: [getTeamListRtkKey, params],
    queryFn: async ({ queryKey }) => {
      const [, actualParams] = queryKey;
      const response = await getTeamListApi(actualParams as { page?: number; page_size?: number } | undefined);
      return response;
    },
    ...options,
  });
}

export function useAddTeamMutation() {
  const queryClient = useQueryClient();
  return useMutation<any, Error, { name: string, email: string }>({
    mutationKey: [addTeamRtkKey],
    mutationFn: async (payload: any) => {
      const response = await addTeamApi(payload);
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [getTeamListRtkKey] });
    },
  });
}

export function useUpdateTeamMutation(team_id: string) {
  const queryClient = useQueryClient();
  return useMutation<any, Error, { name: string, email: string, description?: string | null }>({
    mutationKey: [updateTeamRtkKey, team_id],
    mutationFn: async (payload: any) => {
      const response = await updateTeamApi(payload, team_id);
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [getTeamListRtkKey] });
    },
  });
}

export function useDeleteTeamMutation() {
  const queryClient = useQueryClient();
  return useMutation<any, Error, string>({
    mutationKey: [deleteTeamRtkKey],
    mutationFn: async (team_id: string) => {
      const response = await deleteTeamApi(team_id);
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [getTeamListRtkKey] });
    },
  });
}

export function useGetMemberListQuery(params?: { team_id?: string; page?: number; page_size?: number }, options?: any) {
  return useQuery<any, Error, any>({
    queryKey: [getMemberListRtkKey, params],
    queryFn: async ({ queryKey }) => {
      const [, actualParams] = queryKey;
      const response = await getMemberListApi(actualParams as { team_id?: string; page?: number; page_size?: number } | undefined);
      return response;
    },
    enabled: !!params?.team_id,
    ...options,
  });
}

export function useAddMemberMutation() {
  const queryClient = useQueryClient();
  return useMutation<any, Error, any>({
    mutationKey: [addMemberRtkKey],
    mutationFn: async (payload) => {
      const response = await addMemberApi(payload);
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [getMemberListRtkKey] });
    },
  });
}

export function useUpdateMemberMutation(member_id: string) {
  const queryClient = useQueryClient();
  return useMutation<any, Error, any>({
    mutationKey: [updateMemberRtkKey],
    mutationFn: async (payload) => {
      const response = await updateMemberApi(payload, member_id);
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [getMemberListRtkKey] });
    },
  });
}

export function useDeleteMemberMutation() {
  const queryClient = useQueryClient();
  return useMutation<any, Error, string>({
    mutationKey: [softDeleteMemberRtkKey],
    mutationFn: async (member_id) => {
      const response = await deleteMemberApi(member_id);
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [getMemberListRtkKey] });
    },
  });
}

export function useQueryGenManifestJSON() {
  return useQuery<any, Error, any>({
    queryKey: [genManifestJSONRtkKey],
    queryFn: async () => {
      const response = await genManifestJSONApi();
      return response;
    },
    enabled: false,
  });
}

export function useQueryCreateEnqJSON() {
  return useQuery<any, Error, any>({
    queryKey: [createEnqJSONRtkKey],
    queryFn: async () => {
      const response = await createEnqJsonApi();
      return response;
    },
    enabled: false,
  });
}

export const isAuthenticated = (): boolean => {
  const token = localStorage.getItem('token');
  return !!token;
};

export const getToken = (): string | null => {
  return localStorage.getItem('token');
};

export const getUser = (): any => {
  const user = localStorage.getItem('user');

  if (!user) {
    clearAuth();
    return null;
  }

  try {
    const parsedUser = JSON.parse(user);

    if (!parsedUser) {
      clearAuth();
      return null;
    }

    return parsedUser;
  } catch {
    clearAuth();
    return null;
  }
};


